import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'bedtimeRoutine'

export default function BedtimeRoutinePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const selectedValue = formData.get('answer') as string

    if (!selectedValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.bedtimeRoutine.heading', { lng: 'en' }),
      answer_key: selectedValue,
      answer: selectedValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Bedtime routine options
  const getBedtimeRoutineOptions = () => [
    {
      value: 'Calm & quiet',
      translationKey: 'pages.onboarding.bedtimeRoutine.options.calmQuiet',
      subtextKey: 'pages.onboarding.bedtimeRoutine.subtexts.calmQuiet',
      emoji: '📖',
    },
    {
      value: 'Light movement',
      translationKey: 'pages.onboarding.bedtimeRoutine.options.lightMovement',
      subtextKey: 'pages.onboarding.bedtimeRoutine.subtexts.lightMovement',
      emoji: '🤸',
    },
    {
      value: 'Tech-based',
      translationKey: 'pages.onboarding.bedtimeRoutine.options.techBased',
      subtextKey: 'pages.onboarding.bedtimeRoutine.subtexts.techBased',
      emoji: '🎧',
    },
    {
      value: 'Not sure yet',
      translationKey: 'pages.onboarding.bedtimeRoutine.options.notSure',
      subtextKey: 'pages.onboarding.bedtimeRoutine.subtexts.notSure',
      emoji: '🤷',
    },
  ]

  // Get the options
  const options = getBedtimeRoutineOptions()

  // Transform options to the format expected by QuestionPage
  const buttons = options.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.bedtimeRoutine.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
